export default "/images/framework/WordShopEng.4a0aaf95.svg?4a0aaf95";